import React from 'react';
import NumberFormat from 'react-number-format';

class WizardItemNumberInput extends React.Component {

	constructor(props) {

		super(props);
		this.state = {
			value: "",
			unit: this.props.data.Options[0].Id
		};

		this.handleChange = this.handleChange.bind(this);
		this.selectRadioBtn = this.selectRadioBtn.bind(this);
		this.trimString = this.trimString.bind(this);
	}

	trimString(str) {
		//remove thousand seperator
		if (this.props.data.NumberGroupSeparator) {
			str = str.split(this.props.data.NumberGroupSeparator).join("");
		}
		//remove decimal seperator
		if (!this.props.data.NumberDecimalSeparator) {
			str = str.replace(this.props.data.NumberDecimalSeparator);
		}
		return str;
	}

	handleChange(e) {
		let trimmedString = this.trimString(e.target.value);
		this.setState({ value: trimmedString });

		let newAnswer = "";

		if (e.target.value.length > 0) {
			newAnswer = Object.assign({}, this.props.data.Answer)
			newAnswer.Value = parseFloat(trimmedString.replace(this.props.data.NumberDecimalSeparator, "."));
			newAnswer.OptionId = this.state.unit;
		}

		this.props.submitAnswer(newAnswer);
	}

	selectRadioBtn(e) {
		this.setState({ unit: e.target.value })
		let newAnswer = Object.assign({}, this.props.data.Answer)
		newAnswer.Value = parseFloat(this.state.value.replace(this.props.data.NumberDecimalSeparator, "."));
		newAnswer.OptionId = e.target.value

		if (this.state.value > 0) {
			this.props.submitAnswer(newAnswer);
		}
	}

	render() {
		let isSingleOption = (this.props.data.ItemType == "NumberInputSingleOption");

		const thousandSeparator = this.props.data.NumberGroupSeparator;
		const decimalSeparator = this.props.data.NumberDecimalSeparator;
		const decimalScale = this.props.data.IsDecimalNumber ? 3 : 0;

		return (

			<div className={"wizard-item wizard-item__single-line  wizard-item__number-input" + (isSingleOption ? " wizard-item__single-line__unit" : "")}>

				<NumberFormat
					value={this.state.value}
					allowEmptyFormatting={true}
					displayType={'input'}
					onChange={this.handleChange}
					decimalScale={decimalScale}
					allowNegative={false}
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					placeholder={this.props.data.PlaceholderText}
					type={this.props.data.IsDecimalNumber ? 'text' : 'tel'}
				/>
				{isSingleOption &&
					<span>{this.props.data.Options[0].Header}</span>
				}

				{!isSingleOption &&
					<div className="wizard-item__number-input--radiobutton wizard-item__radio-button">
						{this.props.data.Options.map((rb, idx) => {
							return (
								<div className="radio-button" key={idx} >
									<input checked={(rb.Id == this.state.unit)} type="radio" id={"rb-" + rb.Id} value={rb.Id} name={this.props.data.Id} onChange={this.selectRadioBtn} />
									<label htmlFor={"rb-" + rb.Id}>{rb.Header}</label>
								</div>
							)
						})}
					</div>
				}
			</div>
		)
	}
}

export default WizardItemNumberInput;